import { Box, Typography } from '@mui/material';
import aerialForest from '../../../assets/cover-images/aerial-forest.jpg';
import gaiaLeafWhite from '../../../assets/corporate-logos/gaia/white_icon.png';
import { BRAND_DISPLAY_FONT, rise, WELCOME_DELAYS } from './welcome-animations';

/**
 * Left brand band of the Welcome dialog: a full-bleed aerial-forest photo under
 * two stacked overlays (a green multiply wash + a darkening gradient for
 * legibility), with an animated leaf medallion at the top and the
 * "Measure. / Report. / Reduce." lockup at the bottom. Mirrors the composition
 * of `auth-brand-panel.tsx`; overlay values are the exact handoff recipe.
 */
export const WelcomeBrandBand = () => (
  <Box
    sx={{
      position: 'relative',
      overflow: 'hidden',
      flex: 'none',
      width: { xs: '100%', md: 262 },
      minHeight: { xs: 150, md: 'auto' },
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      p: '30px 30px 32px',
    }}
  >
    <Box component="img" src={aerialForest} alt="" sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
    <Box sx={{ position: 'absolute', inset: 0, background: '#70942c', mixBlendMode: 'multiply', opacity: 0.46 }} />
    <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(165deg, rgba(58,95,19,.45) 0%, rgba(30,50,12,.2) 40%, rgba(17,30,33,.82) 100%)' }} />

    {/* Leaf medallion — glow + drawing ring + floating leaf */}
    <Box
      sx={{
        position: 'relative',
        zIndex: 2,
        width: 72,
        height: 72,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'wdLeaf .85s cubic-bezier(.2,.85,.25,1) .2s both',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: '150%',
          height: '150%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(163,193,90,.75) 0%, transparent 68%)',
          filter: 'blur(4px)',
          animation: 'wdGlow 1.3s ease-out .2s both',
        }}
      />
      <svg viewBox="0 0 100 100" style={{ position: 'absolute', width: 96, height: 96, transform: 'rotate(-90deg)', overflow: 'visible' }}>
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="rgba(255,255,255,.75)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeDasharray="282.7"
          style={{ animation: 'wdRing 1s cubic-bezier(.3,.7,.2,1) .4s both' }}
        />
      </svg>
      <Box sx={{ display: 'flex', animation: 'wdFloat 5s ease-in-out 1.2s infinite both' }}>
        <Box component="img" src={gaiaLeafWhite} alt="" sx={{ width: 44, height: 44, objectFit: 'contain', filter: 'drop-shadow(0 6px 14px rgba(0,0,0,.28))' }} />
      </Box>
    </Box>

    <Box sx={{ flex: 1 }} />

    {/* Bottom lockup */}
    <Box sx={{ position: 'relative', zIndex: 2, animation: rise(WELCOME_DELAYS.lockup) }}>
      <Typography component="div" sx={{ fontSize: 12, fontFamily: BRAND_DISPLAY_FONT, letterSpacing: '.14em', color: 'rgba(255,255,255,.82)' }}>
        CARBON ACCOUNTING
      </Typography>
      <Typography component="div" sx={{ mt: '12px', fontSize: 32, fontFamily: BRAND_DISPLAY_FONT, lineHeight: 1.08, letterSpacing: '-.015em', textShadow: '0 2px 18px rgba(0,0,0,.3)' }}>
        Measure.<br />Report.<br />Reduce.
      </Typography>
    </Box>
  </Box>
);
